module.exports = __webpack_public_path__ + "static/img/rank_190.f275527.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_190.png
// module id = Jy7c
// module chunks = 0